import React, { Component } from "react";
import {
    Container,
    Box,
    Typography,
    TextField,
    Button,
    Alert,
    CircularProgress,
    Breadcrumbs,
    Link as MuiLink
} from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { isAuthenticated } from "../auth";
import { create } from "./apiForum";
import { singleGroup, groupDetails, sendMessage } from '../group/apigroup';
import { Redirect, Link } from "react-router-dom";
import Select from 'react-select'
import { getFilesForGroup } from '../file/apiFiles';
import Footer from '../core/Footer';
import { EditorState, convertFromRaw, convertToRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { stateToHTML } from 'draft-js-export-html';

class NewForumPost extends Component {
    state = {
        postedgroupId: this.props.match.params.groupId,
        title: "",
        body: "",
        error: "",
        user: {},
        loading: false,
        redirectToProfile: false,
        groupName: '',
        chairEmail: '',
        cochairEmail: '',
        allGroupFiles: [],
        filetoLink: '',
        editorState: EditorState.createEmpty(),
        members: [],
        messagePosted: false,
        submittedEmail: false,
        notifyError: ''
    };

    getGroupInformation = () => {
        singleGroup(this.props.match.params.groupId).then(data => {
            if (data.error) {
                console.log(data.error);
            } else {

                this.setState({
                    group: data
                });
            }
        });



        groupDetails(this.props.match.params.groupId).then(data => {
            if (data.error) {
                console.log(data.error);
            } else {
                this.setState({
                    chairEmail: data.chair.email,
                    cochairEmail: data.cochair.email,
                    groupName: data.name,
                    members: data.members,
                })
            }
        })
    };

    componentDidMount() {
        this.forumpostData = new FormData();
        this.setState({ user: isAuthenticated().user });
        this.getGroupInformation();
        getFilesForGroup(this.state.postedgroupId, isAuthenticated().token).then(files => {
            if (files.error) {
                console.log(files.error);
            } else {
                this.setState({
                    allGroupFiles: files
                })
                console.log(files)
            }
        })
    }

    isValid = () => {
        const { title } = this.state;
        if (title.length === 0) {
            this.setState({ error: "All fields are required", loading: false });
            return false;
        }
        return true;
    };

    handleChange = name => event => {
        let value = "";
        if (name === 'filetoLink') {
            value = event.value
        } else {
            value = event.target.value
        }
        // if (name === 'title') {
        //     this.forumpostData.set("title", event.value);
        // }

        this.setState({ error: "" });

        this.forumpostData.set(name, value);
        this.setState({ [name]: value });
        this.setState({ submittedEmail: true })
    };

    onChange = (editorState) => this.setState({ editorState });

    clickSubmit = event => {
        event.preventDefault();
        this.setState({ loading: true });

        const rawState = JSON.stringify(convertToRaw(this.state.editorState.getCurrentContent()));
        this.forumpostData.set("body", rawState);

        if (this.isValid()) {
            const userId = isAuthenticated().userId;
            const token = isAuthenticated().token;
            this.forumpostData.set('postedgroupId', this.state.postedgroupId)

            create(userId, token, this.forumpostData).then(data => {
                if (data.error) {
                    this.setState({ error: data.error, loading: false });
                    return;
                }
                this.setState({
                    loading: false,
                    title: "",
                    body: "",
                });
                // Only notify the group once the post has actually saved.
                this.sendPostMessage(rawState);
            });
        }
    };


    sendPostMessage(raw) {
        const messageBody = stateToHTML(convertFromRaw(JSON.parse(raw)))

        let userEmailList = []

        this.state.members.map((c, i) => (
            userEmailList.push(c.email)
        ))

        const mailMessage = {
            "subject": "New Post From the SDSIC " + this.state.groupName,
            "from": "donotreply@sdsconsortium.com",
            "to": "donotreply@sdsconsortium.com",
            "bcc": userEmailList,
            // "to": [{ "name": isAuthenticated().email, "address": isAuthenticated().email }],
            // "bcc": userEmailList,
            "text": `New Post in the ${this.state.groupName} page, ${messageBody}`,
            "html": `<html><body><h4>New Post in the ${this.state.groupName} page,</h4>${messageBody}</body></html>`
        }

        sendMessage(mailMessage).then(data => {
            if (data && data.error) {
                this.setState({ notifyError: data.error });
            }
        });

        this.setState({
            loading: false,
            editorState: EditorState.createEmpty(),
            submittedEmail: false,
            messagePosted: true
        });
    };

    showSuccess() {
        if (!this.state.messagePosted) return null;
        return (
            <Alert severity="success" sx={{ mb: 2 }}>
                Message was Posted!
            </Alert>
        )
    };

    // The post saved but the group notification email did not go out - say so
    // rather than leaving members silently uninformed.
    showNotifyError() {
        if (!this.state.notifyError) return null;
        return (
            <Alert severity="warning" sx={{ mb: 2 }}>
                Your post was saved, but the group could not be notified by email: {this.state.notifyError}
            </Alert>
        )
    };

    newPostForm = (title, body, groupId, allGroupFiles, editorState) => (
        <Box component="form" sx={{ mt: 2 }}>
            <TextField
                fullWidth
                label="Title"
                onChange={this.handleChange("title")}
                type="text"
                id="title"
                value={title}
                margin="normal"
                variant="outlined"
            />

            <Box sx={{ my: 2 }}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                    Body
                </Typography>
                <Editor
                    editorState={this.state.editorState}
                    wrapperClassName="demo-wrapper"
                    editorClassName="editer-content"
                    onEditorStateChange={this.onChange}
                    wrapperStyle={{ border: "2px solid #1976d2", marginBottom: "10px", borderRadius: "4px" }}
                    editorStyle={{ height: "300px", padding: "10px" }}
                />
            </Box>

            <Box sx={{ my: 2 }}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                    Link a file (optional)
                </Typography>
                <Select
                    name="filetoLink"
                    options={allGroupFiles.map((c, i) => (
                        {
                            value: c._id,
                            label: c.fileCategory + " : " + c.title
                        }
                    ))}
                    onChange={this.handleChange("filetoLink")}
                    isSearchable={true}
                    placeholder={'type a file to search'}
                />
            </Box>

            <Button
                onClick={this.clickSubmit}
                variant="contained"
                color="primary"
                disabled={!this.state.submittedEmail}
                sx={{ mt: 2 }}
            >
                Create Forum Message
            </Button>
        </Box>
    );

    render() {
        const {
            title,
            body,
            error,
            loading,
            redirectToProfile,
            groupId,
            allGroupFiles,
            editorState
        } = this.state;

        if (redirectToProfile) {
            return <Redirect to={`/singlegroup/${this.state.postedgroupId}`} />;
        }

        return (
            <>
                <Container>
                    <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} sx={{ my: 2 }}>
                        <MuiLink component={Link} to="/usershome" underline="hover" color="inherit">
                            Home
                        </MuiLink>
                        <MuiLink component={Link} to="/grouplist" underline="hover" color="inherit">
                            Back to committee list
                        </MuiLink>
                        <Typography color="text.primary">{this.state.groupName}</Typography>
                    </Breadcrumbs>

                    <Typography variant="h4" sx={{ mt: 5, mb: 5 }}>
                        You are creating a new post in the {this.state.groupName}
                    </Typography>

                    {error && (
                        <Alert severity="error" sx={{ mb: 2 }}>
                            {error}
                        </Alert>
                    )}

                    {loading && (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
                            <Box sx={{ textAlign: 'center' }}>
                                <CircularProgress sx={{ mb: 2 }} />
                                <Typography variant="h6">Loading...</Typography>
                            </Box>
                        </Box>
                    )}

                    {this.showSuccess()}
                    {this.showNotifyError()}
                    {!this.state.messagePosted && this.newPostForm(title, body, groupId, allGroupFiles, editorState)}
                </Container>

                <Footer />
            </>
        );
    }
}

export default NewForumPost;